import downloadUrl from './downloadUrl';

/**
 * @param {string} fileName
 * @param {Blob} blob
 */
export default function downloadBlob(fileName, blob) {
    const url = URL.createObjectURL(blob);

    downloadUrl(fileName, url);

    URL.revokeObjectURL(url);
}